import { defaultAnimations } from "./defaultAnimations";

export default class AnimationTune {
  static get isTune() {
    return true;
  }

  /**
   *
   * @param api
   * @param data
   * @param settings
   * @param block
   */
  constructor({ api, data, config, block }) {
    this.api = api;
    this.block = block;
    this.settings = config;
    this.animations = defaultAnimations();

    // if (this.settings.animations && this.settings.animations.length > 0) {
    //   this.animations = this.settings.animations;
    // }

    this.data = {
      animation: data?.animation ?? this.animations[0],
      animationIndex: data?.animationIndex ?? 0,
    };

    this._CSS = {
      wrapper: "cdx-animations-settings",
      select: "cdx-settings-select",
      tuneWrapper: "editor-block-tune",
      tuneTitle: "editor-block-tune-title",
      tuneText: "editor-block-tune-text",
      tuneInput: "editor-block-tune-input",
      tuneButton: "editor-block-tune-button",
      tuneContent: "editor-block-tune-content-container",
      // fragment: 'fragment',
    };
  }

  /**
   * rendering block tune
   * @returns {*}
   */
  render() {
    const { animation, animationIndex } = this.data;

    const wrapper = document.createElement("div");
    const title = document.createElement("label");
    const selectContainer = document.createElement("div");
    const select = document.createElement("select");
    const indexNumContainer = document.createElement("div");
    const indexNumLabel = document.createElement("label");
    const indexNum = document.createElement("input");

    wrapper.classList.add(this._CSS.wrapper, this._CSS.tuneWrapper);
    title.classList.add(this._CSS.tuneTitle);
    selectContainer.classList.add("select-container");
    select.classList.add(this._CSS.select, this._CSS.tuneInput);
    indexNumLabel.classList.add(this._CSS.tuneTitle);
    indexNumContainer.classList.add(
      "index-num-container",
      this._CSS.tuneContent,
    );
    indexNum.classList.add(this._CSS.tuneInput);

    title.innerText = "Animation";
    indexNumLabel.innerText = "Animation Index";
    select.setAttribute("name", "animation");
    indexNum.setAttribute("type", "number");
    indexNum.setAttribute("min", "0");
    indexNum.setAttribute("value", "0");
    indexNumContainer.style.display =
      this.data.animationIndex !== undefined ? "block" : "none";

    this.animations.forEach((animationItem, index) => {
      const option = document.createElement("option");
      option.setAttribute("value", animationItem.class);
      option.innerHTML = animationItem.label;

      if (animationItem.class === animation.class) {
        option.setAttribute("selected", true);
      }

      select.appendChild(option);
    });

    select.addEventListener("change", () => {
      const value = select.value;
      let animationItem;

      this.animations.forEach((item) => {
        if (item.class === value) {
          animationItem = item;
        }
      });

      this.data.animation = animationItem;

      if (animationItem.label !== "none") {
        indexNumLabel.style.display = "block";
        indexNumContainer.style.display = "block";
      } else {
        indexNumLabel.style.display = "none";
        indexNumContainer.style.display = "none";
      }

      this.block.dispatchChange();
    });

    indexNum.value = animationIndex || 0;

    indexNum.addEventListener("input", () => {
      const indexValue = parseInt(indexNum.value, 10);
      this.data.animationIndex = indexValue;
      this.block.dispatchChange();
    });

    if (animation.label !== "none") {
      indexNumLabel.style.display = "block";
      indexNumContainer.style.display = "block";
    }

    indexNumContainer.appendChild(indexNum);
    selectContainer.appendChild(select);
    wrapper.appendChild(title);
    wrapper.appendChild(selectContainer);
    wrapper.appendChild(indexNumLabel);
    wrapper.appendChild(indexNumContainer);
    return wrapper;
  }
  /**
   * save
   * @returns {*}
   */
  save() {
    return this.data;
  }
}
